(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
      function initAccountDrawer() {
        const drawer = document.getElementById('AccountDrawer');
        if (!drawer) return;

        const trigger = document.getElementById('account-icon-bubble');
        const overlay = document.getElementById('AccountDrawer-Overlay');
        const closeBtn = document.getElementById('AccountDrawer-Close');

        function openDrawer() {
          drawer.classList.add('animate', 'active');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
          closeBtn && closeBtn.focus();
        }

        function closeDrawer() {
          drawer.classList.remove('active', 'animate');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflow-hidden');
          trigger && trigger.focus();
        }

        if (trigger) {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            openDrawer();
          });
          trigger.addEventListener('keydown', function (e) {
            if (e.code === 'Space') {
              e.preventDefault();
              openDrawer();
            }
          });
        }

        overlay && overlay.addEventListener('click', closeDrawer);
        closeBtn && closeBtn.addEventListener('click', closeDrawer);

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && drawer.classList.contains('active')) {
            closeDrawer();
          }
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAccountDrawer);
      } else {
        initAccountDrawer();
      }

      document.addEventListener('shopify:section:load', initAccountDrawer);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cross-sell__qty').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-action="decrement"]')?.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min || 1, 10);
      if (val > min) input.value = val - 1;
      input.dataset.userSet = 'true';
    });
    qty.querySelector('[data-action="increment"]')?.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
      input.dataset.userSet = 'true';
    });
    input.addEventListener('input', () => { input.dataset.userSet = 'true'; });
  });

  // Recommended cross-sell quantities scale with the main product quantity:
  // crossQty = ceil(baseRecommended x mainQty), min 1. A cross-sell qty the
  // shopper changed themselves is left alone.
  (function () {
    const mainQty = document.querySelector('.product-hero__qty-input');
    if (!mainQty) return;
    const inputs = document.querySelectorAll('.cross-sell__qty-input[data-base-qty]');
    if (!inputs.length) return;

    const sync = () => {
      const m = parseInt(mainQty.value, 10) || 1;
      inputs.forEach((input) => {
        if (input.dataset.userSet === 'true') return;
        const base = parseFloat(input.dataset.baseQty);
        if (!Number.isFinite(base) || base <= 0) return;
        input.value = Math.max(1, Math.ceil(base * m));
      });
    };

    mainQty.addEventListener('input', sync);
    mainQty.addEventListener('change', sync);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    const bar = document.querySelector('[data-product-sticky-atc]');
    if (!bar) return;

    // Relocate to <body> so position:fixed is always viewport-relative, even if a
    // transformed/contained ancestor (e.g. an injected app wrapper) would otherwise
    // capture it and pin the bar inside that box.
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    // Quantity stepper (the bar now lives outside .product-hero, so wire it up here).
    // This input duplicates .product-hero__qty-input, but the tier-price recompute
    // (highlightVolumeTier/applyTierPriceToHero in product-hero.liquid) only reads the
    // main hero input via document.querySelector. Changing qty here must therefore
    // drive the main input as the single source of truth, not just mutate itself.
    const mainInput = document.querySelector('.product-hero__qty-input.quantity__input');

    bar.querySelectorAll('.product-sticky-atc__qty').forEach((qty) => {
      const input = qty.querySelector('input');
      if (!input) return;

      const syncToMain = (val) => {
        input.value = val;
        if (!mainInput) return;
        mainInput.value = val;
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      qty.querySelector('[data-action="decrement"]')?.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        const min = parseInt(input.min || 1, 10);
        if (val > min) syncToMain(val - 1);
      });
      qty.querySelector('[data-action="increment"]')?.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        syncToMain(val + 1);
      });
      input.addEventListener('input', () => syncToMain(parseInt(input.value, 10) || 1));
      input.addEventListener('change', () => syncToMain(parseInt(input.value, 10) || 1));

      // Main input can also change elsewhere (its own stepper, a Bundler tier click) —
      // mirror it back so the sticky bar never shows a stale quantity.
      mainInput?.addEventListener('input', () => {
        if (input.value !== mainInput.value) input.value = mainInput.value;
      });
    });

    // Show the bar once the main buy controls scroll out of view.
    const mainBuy = document.querySelector('.product-hero__form-row');
    if (!mainBuy || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0 }
    );

    observer.observe(mainBuy);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-dropdown"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-variant-select]').forEach((select) => {
    if (select.dataset.bound) return;
    select.dataset.bound = 'true';
    select.addEventListener('change', () => {
      if (select.value) window.location.href = select.value;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-variant-select]').forEach((select) => {
    if (select.dataset.bound) return;
    select.dataset.bound = 'true';
    select.addEventListener('change', () => {
      if (select.value) window.location.href = select.value;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
